import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { RouterConfig, useIsFrontendStyleDefault, useIsFrontendStyleRed } from '@edikk-edikk/country-frontend';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import ArrowRightSvg from '@edikk-edikk/country-layout-black-icon/src/arrow-right.svg';
import { CityForSelectType } from '#home/types';
import cardLocationCityChooserHolderCss from '../assets/card-location-city-chooser-holder.module.scss';

type PropsType = {
  selectedCity: CityForSelectType|null;
};

const CardLocationCityChooserHolderButton: FC<PropsType> = ({
  selectedCity,
}) => {
  const navigate = useNavigate();
  const isFrontendStyleDefault = useIsFrontendStyleDefault();
  const isFrontendStyleRed = useIsFrontendStyleRed();

  const handlerClick = useCallback(() => {
    if (!selectedCity) {
      return;
    }

    navigate(selectedCity.url, {
      state: {
        routerConfig: RouterConfig.initForCity(selectedCity.value),
      },
    });
  }, [navigate, selectedCity]);

  return (
    <Button
      variant={ButtonVariant.unstyled}
      onClick={handlerClick}
      aria-label="Go"
      textBlack={isFrontendStyleDefault}
      textWhite={isFrontendStyleRed}
      disabled={!selectedCity}
    >
      <SvgIcon
        Component={ArrowRightSvg}
        additionalClassName={cardLocationCityChooserHolderCss.cardLocationCityChooserHolder__buttonIcon}
      />
    </Button>
  );
};

export { CardLocationCityChooserHolderButton };
